import { ChevronDown } from "@untitledui/icons"

import { cx } from "@/lib/utils/cx"

/** A select that reads as text with a chevron; the box appears on hover
 *  and focus. Keeps tables quiet without hiding that it can change. */
export function TextSelect({
  value,
  options,
  onChange,
  ariaLabel,
  className,
}: {
  value: string
  options: Array<{ value: string; label: string }>
  onChange: (v: string) => void
  ariaLabel: string
  className?: string
}) {
  return (
    <span className={cx("relative inline-flex", className)}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label={ariaLabel}
        className={cx(
          "h-9 appearance-none rounded-md border border-transparent bg-transparent pl-2 pr-7 text-[13.5px] text-zinc-900",
          "hover:border-zinc-300 hover:bg-white focus:border-zinc-900 focus:bg-white focus:outline-none focus:ring-2 focus:ring-zinc-900/10",
        )}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2 top-1/2 size-3.5 -translate-y-1/2 text-zinc-500" aria-hidden />
    </span>
  )
}
